import { request } from '@/axios';
// 切换个人/团队版
export function switchTeam() {
    return request<{}>({
        api: '/api/team/switchTeam',
        method: 'get',
        notToast: false
    });
}
